import { Route, State as RouteState } from 'config/routes';
import { call, put, select } from 'redux-saga/effects';
import { queryData } from 'store/sagas/apiService';
import { LoadType } from 'store/sagas/apiService/types';
import { resetDomainData } from 'store/state/domainData/actions';
import { prevRouteSelector } from 'store/state/selectors/router';
import { RealEstateLevel, IOfficeByIdData } from 'utils/entities';
import { managedOfficeSelector } from 'store/state/domainData/selectors';
import { navigateTo } from 'store/state/router/actions';
import { officeDataByIdSelector } from 'store/state/domainData/selectors/common';


function* loadOfficeData() {
  const managedOfficeId: string | null = yield select(managedOfficeSelector);

  if (!managedOfficeId) {
    yield put(navigateTo(Route.AgentConsoleHomePage, {}, { replace: true }));
  }
  else {
    const prevRoute: RouteState | null = yield select(prevRouteSelector);

    if (prevRoute) {
      yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
      yield put(resetDomainData({ loadType: LoadType.OfficeBulletinsById }));
    }

    yield call(queryData, { loadType: LoadType.GetPublicRealEstateOfficeById, meta: { variables: { officeId: managedOfficeId } } });

    const officeData: IOfficeByIdData = yield select(officeDataByIdSelector);

    if (officeData) {
      yield call(queryData, { loadType: LoadType.OfficeBulletinsById, meta: { variables: { id: managedOfficeId, level: RealEstateLevel.Public } } });
    }
    else {
      yield put(navigateTo(Route.AgentConsoleHomePage, {}, { replace: true }));
    }
  }
}

export function* officeProfilePageHandler() {
  yield call(loadOfficeData);
}
